export default __webpack_public_path__ + "static/step-verify-59e09f06ab11a465386cb41806e67cb5.png";